import { render, staticRenderFns } from "./Framework-details.vue?vue&type=template&id=39db6b99"
import script from "./Framework-details.vue?vue&type=script&lang=js"
export * from "./Framework-details.vue?vue&type=script&lang=js"
import style0 from "./Framework-details.vue?vue&type=style&index=0&id=39db6b99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports